export default "__VITE_ASSET__CYTDzspL__"